"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsNewCustomerProfileEntityCollection = void 0;
const AnalyticsNewCustomerProfileDto_1 = require("./AnalyticsNewCustomerProfileDto");
const AnalyticsNewCustomerProfileEntity_1 = require("./AnalyticsNewCustomerProfileEntity");
const EntityCollectionBase_1 = require("../GS/EntityCollectionBase");
class AnalyticsNewCustomerProfileEntityCollection extends EntityCollectionBase_1.EntityCollectionBase {
    constructor(dependencies) {
        super();
        this._dependencies = dependencies;
    }
    toDtos() {
        return this._dtos.map((dto) => (new AnalyticsNewCustomerProfileDto_1.AnalyticsNewCustomerProfileDto(dto)));
    }
    get items() {
        if (this._items.length === 0 && this._dtos.length > 0) {
            for (const analyticsNewCustomerProfileDto of this._dtos) {
                this._items.push(new AnalyticsNewCustomerProfileEntity_1.AnalyticsNewCustomerProfileEntity(this._dependencies, analyticsNewCustomerProfileDto));
            }
        }
        return this._items;
    }
    loadAsync(query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.clearErrors();
                this._setState("busy");
                this._emit("before-loadAsync");
                const { dtos, objectsPerPage, pageNumber, totalObjectCount, totalPageCount } = yield this._dependencies.analyticsNewCustomerProfileDatastore
                    .findAsync(query);
                this._items = [];
                this._dtos = dtos;
                this.objectsPerPage = objectsPerPage;
                this.pageNumber = pageNumber;
                this.totalObjectCount = totalObjectCount;
                this.totalPageCount = totalPageCount;
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AnalyticsNewCustomerProfileEntityCollection = AnalyticsNewCustomerProfileEntityCollection;
//# sourceMappingURL=AnalyticsNewCustomerProfileEntityCollection.js.map